import { render } from "./App.vue?vue&type=template&id=03e8e7a6&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=03e8e7a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holst\\Documents\\smoltvagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e8e7a6"]])

export default __exports__